'use client';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useSearchParams } from 'next/navigation';

function Header() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const page = searchParams.get('page');

  const routeBackProfile = (tab: string) => {
    router.push(`/?tab=${encodeURIComponent(tab)}`);
  };

  return (<>
    {page ? 
      <div className="bg-orange-100 px-4 py-2 flex items-center justify-between sticky top-0 z-10">
        <button className="p-2" onClick={() => routeBackProfile('profile')}>
          <svg className="w-6 h-6 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        
        <div className="text-center">
          <h1 className="text-xl font-bold text-orange-600">
            {page === 'tier' && 'ระดับสมาชิก'}
            {page === 'history' && 'ประวัติการสั่งซื้อ'}
            {page === 'repassword' && 'เปลี่ยนรหัสผ่าน'}
          </h1>
        </div>
        <div className="p-4"></div>
      </div>
    : 
      <div className="bg-orange-100 py-1 flex items-center justify-between">
        <div className="flex items-center">
          <Image src="/logo1.png" alt="Description of the image" width={60} height={60} />
          <Image src="/logo-text.png" alt="Description of the image" width={150} height={60}/>
        </div>
      </div>
    } 
  </>);
}

export default function Home() {
  return (<Header />);
}